import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"
import "firebase/storage"

const app = firebase.initializeApp({
  apiKey: "AIzaSyBUERtx3N8k6raWgB9js2v4bcI2aCfqP1I",
  authDomain: "react-auth-development-9df00.firebaseapp.com",
  projectId: "react-auth-development-9df00",
  storageBucket: "react-auth-development-9df00.appspot.com",
  messagingSenderId: "15939906283",
  appId: "1:15939906283:web:96cc05c353bad1bf15acae"
})

export const firestore = app.firestore()
export const database = {
  folders: firestore.collection('folders'),
  files: firestore.collection('files'),
  formatDoc: doc => {
    return { id: doc.id, ...doc.data()}
  },
  getCurrentTimestamp: firebase.firestore.FieldValue.serverTimestamp
}
export const storage = app.storage()
export const auth = app.auth()
export default app
